import { addYachtsOrder, yachtsDetail, calcYachtOrder } from '@/api'
import { success, fail, failMsg } from '@/libs/utils'
import { Message } from 'element-ui'
import { Loading } from 'element-ui'
const state = {
    payInfo: {},
    // 游艇详情
    yachtsDetail: {},
    // 菜单数据
    yachtsMenu: [],
    // 游艇玩具
    yachtsToys: [],
    // 水上运动
    waterSports: [],
    // 计算游艇金额
    calcYachtOrderTotal: {},
}

const actions = {
    // 创建游艇订单
    async addYachtsOrder({ commit }, context) {
        Loading.service({
            lock: false,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            customClass: 'orderLoading',
        })
        context.fastAddOrder = context.fastAddOrder === 1 ? 1 : 0
        try {
            let data = await addYachtsOrder(context)
            commit('ADDYACHTSORDER', data)

            if (data.result) {
                if (context.fastAddOrder === 0) {
                    location.href = data.data
                } else {
                    Loading.service().close()
                    success()
                }
                return Promise.resolve()
            }
        } catch (error) {
            Message.error(error)
            Loading.service().close()
            return new Promise.reject()
        }
    },
    // 根据productId获取游艇的详情
    async getYachtsDetail({ commit }, context) {
        let data = await yachtsDetail(context)
        // 菜单
        let result = data.data.cateringComboPackages

        // 游艇玩具
        let result2 = data.data.specialServicePackages.filter(
            item => item.identify == 'af3369e4-29b7-46ca-9a1b-96601f3508fa',
        )

        // 水上运动
        let result1 = data.data.specialServicePackages.filter(
            item => item.identify == '9bc25d92-07cb-4a6f-9b36-f2e382934525',
        )
        commit(
            'getYachtsToys',
            result2.map(item => {
                return {
                    ...item,
                    checked: false,
                    number: item.defaultNumber ? item.defaultNumber : 1,
                    name: item.serviceName,
                    quantity: item.defaultNumber ? item.defaultNumber : 1,
                    max: item.maxNumber,
                    defaultNum: item.defaultNumber,
                }
            }),
        )
        commit(
            'getYachtsMenu',
            result.map(item => {
                return {
                    ...item,
                    checked: false,
                    number: 0,
                    name: item.menuName,
                    quantity: 0,
                    max: item.maxNumber,
                    min: item.minNumber,
                }
            }),
        )
        commit(
            'getWaterSports',
            result1.map(item => {
                return {
                    ...item,
                    checked: false,
                    name: item.serviceName,
                    quantity: item.lockNumber ? item.defaultNumber : item.minNumber ? item.minNumber : 1,
                    max: item.maxNumber,
                    defaultNum: item.defaultNumber,
                }
            }),
        )
        commit('getYachtsDetailById', data)
    },
    // 计算游艇金额
    async calcYachtOrderTotal({ commit }, context) {
        try {
            let data = await calcYachtOrder(context)
            commit('CALCYACHTORDER', data.data)
        } catch (error) {
            // console.log(error);
        }
    },
}

const mutations = {
    ADDYACHTSORDER(state, params) {
        state.payInfo = params
    },
    // 修改state里的游艇详情信息数据
    getYachtsDetailById(state, params) {
        state.yachtsDetail = params
    },
    getYachtsMenu(state, params) {
        state.yachtsMenu = params
    },
    getYachtsToys(state, params) {
        state.yachtsToys = params
    },
    getWaterSports(state, params) {
        state.waterSports = params
    },
    CALCYACHTORDER(state, params) {
        state.calcYachtOrderTotal = params
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
